<div *ngIf="isMobile; else blockContent" mat-dialog-content>
  <ng-container *ngTemplateOutlet="blockContent"></ng-container>
</div>

<ng-template #blockContent>
  <section role="region" *ngIf="(loading$ | async) === false">
    <button type="button" class="btn-clean contact-modal__cross" (click)="closeDialog()">
      <mat-icon svgIcon="cross" aria-label="Cross icon"></mat-icon>
    </button>
    <picture *ngIf="data.contactType === ContactTypeEnum.localMission">
      <source
        srcset="
          /assets/images/unml/unml.webp,
          /assets/images/unml/unml@2x.webp 2x,
          /assets/images/unml/unml@3x.webp 3x,
          /assets/images/unml/unml@4x.webp 4x
        "
        type="image/webp"
      />
      <source
        srcset="
          /assets/images/unml/unml.jpg,
          /assets/images/unml/unml@2x.jpg 2x,
          /assets/images/unml/unml@3x.jpg 3x,
          /assets/images/unml/unml@4x.jpg 4x
        "
      />
      <img
        class="contact-modal__image"
        src="/assets/images/unml/unml.jpg"
        alt="Union Nationales des Missions Locales"
        loading="lazy"
      />
    </picture>

    <h1 role="heading" class="contact-modal__title">
      <ng-container *ngIf="data.contactType === ContactTypeEnum.normal">Contactez-nous&nbsp;!</ng-container>
      <ng-container *ngIf="data.contactType === ContactTypeEnum.localMission"
        >Vous avez besoin d&apos;accompagnement pour bâtir votre projet professionnel&nbsp;?</ng-container
      >
      <ng-container *ngIf="data.contactType === ContactTypeEnum.organizeEvent"
        >Vous souhaitez organiser un événement de recrutement&nbsp;?</ng-container
      >
    </h1>
    <h2 role="heading" class="contact-modal__subtitle">
      <ng-container *ngIf="data.contactType === ContactTypeEnum.normal"
        >Nos équipes vous répondront dans les plus brefs délais&nbsp;!</ng-container
      >
      <ng-container *ngIf="data.contactType === ContactTypeEnum.localMission">Nous vous rappelons&nbsp;!</ng-container>
      <ng-container *ngIf="data.contactType === ContactTypeEnum.organizeEvent"
        >Dans le cadre de l&apos;initiative #1jeune1solution, nous vous accompagnons dans la réalisation de vos
        événements de recrutement.</ng-container
      >
    </h2>
  </section>

  <ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
    <form id="contact-form" class="contact-modal__form" [formGroup]="form" (ngSubmit)="closeDialogOnSend()">
      <mat-form-field class="contact-modal__form__firstName" [style.-ms-grid-column]="1" [style.-ms-grid-row]="1">
        <mat-label>Prénom</mat-label>
        <input type="text" formControlName="firstName" autocomplete="given-name" matInput />
        <mat-error *ngIf="firstName?.errors?.required || firstName.errors?.whitespace">Le prénom est requis</mat-error>
      </mat-form-field>

      <mat-form-field class="contact-modal__form__lastName" [style.-ms-grid-column]="3" [style.-ms-grid-row]="1">
        <mat-label>Nom</mat-label>
        <input type="text" formControlName="lastName" autocomplete="family-name" matInput />
        <mat-error *ngIf="lastName?.errors?.required || lastName.errors?.whitespace">Le nom est requis</mat-error>
      </mat-form-field>

      <mat-form-field
        *ngIf="data.contactType === ContactTypeEnum.localMission"
        class="contact-modal__form__age"
        [style.-ms-grid-column]="ieColumn"
        [style.-ms-grid-row]="ieRow"
      >
        <mat-label>Âge</mat-label>
        <mat-select
          formControlName="age"
          #ageSelect="matSelect"
          aria-label="Contact mission locale, liste déroulante réduite pour sélectionner l'âge"
        >
          <mat-option *ngFor="let age of ages; trackBy: trackByAge" [value]="age">{{ age }} ans</mat-option>
        </mat-select>
        <mat-error *ngIf="age?.errors?.required || age?.errors?.whitespace">L'âge est requis</mat-error>
      </mat-form-field>

      <mat-form-field
        *ngIf="data.contactType === ContactTypeEnum.normal || data.contactType === ContactTypeEnum.organizeEvent"
        class="contact-modal__form__mail"
        [style.-ms-grid-column]="ieColumn"
        [style.-ms-grid-row]="ieRow"
      >
        <mat-label>Email</mat-label>
        <input type="text" formControlName="mail" autocomplete="email" matInput />
        <mat-error *ngIf="mail?.errors?.required">L&apos;adresse email est requise</mat-error>
        <mat-error *ngIf="mail?.errors?.email">L&apos;adresse email est invalide</mat-error>
      </mat-form-field>

      <mat-form-field
        *ngIf="data.contactType === ContactTypeEnum.organizeEvent"
        class="contact-modal__form__company"
        [style.-ms-grid-column]="ieColumn"
        [style.-ms-grid-row]="ieRow"
      >
        <mat-label>Organisme</mat-label>
        <input type="text" formControlName="company" matInput />
        <mat-error *ngIf="company?.errors?.required">Le nom de l&apos;organisme est requis</mat-error>
      </mat-form-field>

      <mat-form-field
        class="contact-modal__form__phone"
        [style.-ms-grid-column]="ieColumn"
        [style.-ms-grid-row]="ieRow"
      >
        <mat-label>Téléphone</mat-label>
        <input type="text" formControlName="phone" autocomplete="tel-national" matInput />
        <mat-error *ngIf="phone?.errors?.required">Le numéro de téléphone est requis</mat-error>
        <mat-error *ngIf="phone?.errors?.phone">Le numéro de téléphone est incorrect</mat-error>
      </mat-form-field>

      <mat-form-field
        *ngIf="data.contactType === ContactTypeEnum.localMission"
        class="contact-modal__form__mail contact-modal__form__mail--home"
        [style.-ms-grid-column]="ieColumn"
        [style.-ms-grid-row]="ieRow"
      >
        <mat-label>Adresse e-mail</mat-label>
        <input type="text" formControlName="mail" autocomplete="email" matInput />
        <mat-hint>Optionnel</mat-hint>
        <mat-error *ngIf="mail?.errors?.email">L&apos;adresse email est invalide</mat-error>
      </mat-form-field>

      <mat-form-field
        *ngIf="data.contactType === ContactTypeEnum.organizeEvent"
        class="contact-modal__form__position"
        [style.-ms-grid-column]="ieColumn"
        [style.-ms-grid-row]="ieRow"
      >
        <mat-label>Poste</mat-label>
        <input type="text" formControlName="position" matInput />
        <mat-error *ngIf="position?.errors?.required">Le poste est requis</mat-error>
      </mat-form-field>

      <mat-form-field
        *ngIf="data.contactType === ContactTypeEnum.normal || data.contactType === ContactTypeEnum.organizeEvent"
        class="contact-modal__form__content"
        [style.-ms-grid-column-span]="3"
        [style.-ms-grid-row]="ieRow"
      >
        <mat-label>{{
          data.contactType === ContactTypeEnum.normal ? 'Votre message' : 'Description rapide de votre événement'
        }}</mat-label>
        <textarea
          matInput
          formControlName="content"
          cdkTextareaAutosize
          cdkAutosizeMinRows="4"
          cdkAutosizeMaxRows="6"
        ></textarea>

        <mat-error *ngIf="content.errors?.required">Ce bloc est requis </mat-error>
      </mat-form-field>
    </form>
  </ng-container>

  <button
    *ngIf="(loading$ | async) === false"
    class="btn-clean contact-modal__btn"
    type="submit"
    form="contact-form"
    [style.-ms-grid-column]="ieColumn"
    [style.-ms-grid-row]="ieRow"
  >
    <ng-container *ngIf="data.contactType === ContactTypeEnum.localMission">Je souhaite être rappelé</ng-container>
    <ng-container
      *ngIf="data.contactType === ContactTypeEnum.organizeEvent || data.contactType === ContactTypeEnum.normal"
      >Envoyer
    </ng-container>
  </button>

  <ng-container *ngIf="(loading$ | async) === false">
    <ng-container *ngIf="data.contactType === ContactTypeEnum.requestEventParticipation">
      <ul>
        <li>
          <app-form-rgpd-info [info]="rgpdInfo[0]"></app-form-rgpd-info>
        </li>
        <li>
          <app-form-rgpd-info [info]="rgpdInfo[1]"></app-form-rgpd-info>
        </li>
      </ul>
    </ng-container>

    <app-form-rgpd-info *ngIf="data.contactType === ContactTypeEnum.localMission">
      Un traitement de données à caractère personnel est mis en oeuvre par la Direction Générale de l&apos;Emploi et de
      la Formation Professionnelle (DGEFP), à partir des données collectées dans le formulaire ci-dessus. En cliquant
      sur "je souhaite être rappelé", vos données seront transmises à la mission locale de la zone géographique dans
      laquelle vous résidez pour que celle-ci prenne contact avec vous.
      <a
        class="link--primary link--inline-block"
        [routerLink]="['/', FeaturesRoutingEnum.Privacy]"
        (click)="closeDialog()"
        target="_blank"
        >En savoir plus sur la gestion de vos données et vos droits</a
      >
    </app-form-rgpd-info>

    <app-form-rgpd-info
      *ngIf="
        data.contactType !== ContactTypeEnum.localMission &&
        data.contactType !== ContactTypeEnum.requestEventParticipation
      "
    >
      En cliquant sur
      <ng-container
        *ngIf="data.contactType === ContactTypeEnum.organizeEvent || data.contactType === ContactTypeEnum.normal"
      >
        Envoyer,&nbsp;
      </ng-container>
      j&apos;accepte que mes données soient envoyées au partenaire Wizbii qui coordonne les événements sur le portail.
    </app-form-rgpd-info>
  </ng-container>
</ng-template>

<ng-template #loadingTemplate>
  <div class="loader-container">
    <app-checkmark-loader class="loader" [loading]="loadingLoader$ | async">
      <ng-container *ngIf="(loadingLoader$ | async) === true">Envoi en cours</ng-container>
      <ng-container *ngIf="(loadingLoader$ | async) === false"
        >Votre demande a bien été prise en compte&nbsp;! Notre équipe prendra contact avec vous
        rapidement.</ng-container
      >
    </app-checkmark-loader>

    <ng-container>
      <h2 role="heading" class="loader__title">
        <ng-container *ngIf="(loadingLoader$ | async) === true">Envoi en cours</ng-container>
        <ng-container *ngIf="(loadingLoader$ | async) === false"
          >Votre demande a bien été prise en compte&nbsp;!</ng-container
        >
      </h2>
      <p *ngIf="(loadingLoader$ | async) === false" class="loader__subtitle">
        Notre équipe prendra contact avec vous rapidement.
      </p>
    </ng-container>
  </div>
</ng-template>
